import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { CONSTANTS } from 'src/app/constants';

@Component({
  selector: 'app-sales-returns',
  templateUrl: './sales-returns.component.html',
  styleUrls: ['./sales-returns.component.css']
})
export class SalesReturnsComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }

  @Output() errorEmitter = new EventEmitter();

  dataItem: any = {
    chart: {
      numberPrefix: "R$",
      showpercentvalues: "0",
      aligncaptionwithcanvas: "0",
      captionpadding: "0",
      decimals: "1",
      plottooltext:
        "<b>$label</b> - $percentValue",
      centerlabel: "<b>$label</b><br/> $percentValue",
      theme: "gammel",
      palettecolors: "0C9ABE, E14D57"
    },
    data: [
      {
        label: "Vendas",
        value: 0,
      },
      {
        label: "Devoluções",
        value: 0,
      },
    ]
  };

  width = "100%";
  height = "300";
  type = "doughnut2d";
  dataFormat = "json";
  dataSource = this.dataItem;

  listItem: { label: string, type: number, value: number }[] = [
    { label: "VALOR", type: 0, value: 0},
    { label: "QUANTIDADE", type: 1, value: 1},
  ];
  typeSelected: any = 0;

  dataQtdValue = {}
  dataQtdReturn = {}
  dataPriceValue = {}
  dataPriceReturn = {}

  loading: boolean = false;
  errorApi: boolean = false;
  message: string = "";

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  }

  filterItem(item: any) {
    if (item.branch != undefined) {
      this.loading = true;
      let excelInfo: any[] = [];
      this.salesReturnsApi(item).subscribe((data: any) => {
        this.dataItem.data[0].value = data.dataRow[0].item_sale_value;
        this.dataItem.data[1].value = data.dataRow[0].item_return_value;
        this.dataPriceValue = data.dataRow[0].item_sale_value;
        this.dataPriceReturn = data.dataRow[0].item_return_value;
        this.dataQtdValue = data.dataRow[0].item_sale_quantity;
        this.dataQtdReturn = data.dataRow[0].item_return_quantity;
        excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Vendas Valores': 'R$' + data.dataRow[0].item_sale_value.toString(), 'Vendas Quantidade': data.dataRow[0].item_sale_quantity.toString(), 'Devoluções Valores': 'R$' + data.dataRow[0].item_return_value.toString(), 'Devoluções Quantidade': data.dataRow[0].item_return_quantity.toString()});
        excelInfo.unshift({});
        localStorage.setItem('sales-returns-sellers', JSON.stringify(excelInfo));
        this.loading = false;
        this.errorApi = false;
      },
      (error) => {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_SALES_RECORD;
        this.formatErrorMensagem(error.message);
      });
    }
  }

  salesReturnsApi(item: any) {
    return this.api.postSalesReturnsSellerPanel(item.dataMin, item.dataMax, item.branch);
  }

  recoverValues(item: any) {
    this.loading = true;
    if (item === 1) {
      this.dataItem.chart.numberPrefix = "";
      this.dataItem.data[0].value = this.dataQtdValue;
      this.dataItem.data[1].value = this.dataQtdReturn;
      this.loading = false;
    } else {
      this.dataItem.chart.numberPrefix = "R$";
      this.dataItem.data[0].value = this.dataPriceValue;
      this.dataItem.data[1].value = this.dataPriceReturn;
      this.loading = false;
    }
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataSalesReturns = [];
    let objectSalesReturns = localStorage.getItem('sales-returns-sellers');

    objectSalesReturns != null
      ? (dataSalesReturns = JSON.parse(objectSalesReturns))
      : (dataSalesReturns = []);
    const worksheetSalesReturns= XLSX.utils.json_to_sheet(dataSalesReturns);

    const workbook = {
      Sheets: {
        'sales-returns': worksheetSalesReturns,
      },
      SheetNames: [
        'sales-returns',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-sales-returns' + EXCEL_EXTENSION);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: sales-returns \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

}
